import React, { useState } from 'react';
import { Button, Box, Typography, Alert } from '@mui/material';
import { db, auth } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const FirestoreTest: React.FC = () => {
  const [testResult, setTestResult] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  const testFirestore = async () => {
    setIsLoading(true);
    setTestResult('');
    
    try {
      console.log('🔥 FIRESTORE TEST - Starting...');
      
      // Check authentication
      const user = auth.currentUser;
      if (!user) {
        setTestResult('❌ ERROR: User not authenticated');
        return;
      }
      
      console.log('✅ User authenticated:', user.uid);
      
      // Test document path
      const testDocId = 'test-roadmap-123';
      const testRef = doc(db, 'users', user.uid, 'plans', testDocId);
      
      console.log('📍 Test document path:', `users/${user.uid}/plans/${testDocId}`);
      
      // Test write operation
      const testData = {
        day: 14,
        stickers: 17,
        completedActivities: ['day-1', 'day-2', 'day-13', 'day-14'],
        lastCompleted: new Date(),
        testField: 'test-completion'
      };
      
      console.log('💾 Testing write operation with data:', testData);
      await setDoc(testRef, testData, { merge: true });
      console.log('✅ Write operation successful');
      
      // Test read operation
      console.log('📖 Testing read operation...');
      const snap = await getDoc(testRef);
      
      if (snap.exists()) {
        const readData = snap.data();
        console.log('✅ Read operation successful:', readData);
        setTestResult(`✅ SUCCESS: Firestore read/write working!\n\nWritten data: ${JSON.stringify(testData, null, 2)}\n\nRead data: ${JSON.stringify(readData, null, 2)}`);
      } else {
        console.log('❌ Document does not exist after write');
        setTestResult('❌ ERROR: Document was written but cannot be read back');
      }
      
    } catch (error) {
      console.error('❌ FIRESTORE TEST ERROR:', error);
      setTestResult(`❌ ERROR: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, border: '2px solid orange', borderRadius: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        🔥 Firestore Connection Test
      </Typography>
      
      <Button 
        variant="contained" 
        onClick={testFirestore}
        disabled={isLoading}
        sx={{ mb: 2 }}
      >
        {isLoading ? 'Testing...' : 'Test Firestore Connection'}
      </Button>
      
      {testResult && (
        <Alert 
          severity={testResult.includes('SUCCESS') ? 'success' : 'error'}
          sx={{ mt: 2 }}
        >
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>
            {testResult}
          </pre>
        </Alert>
      )}
    </Box>
  );
};

export default FirestoreTest;

